export class AssetsId {
    assetId: number;
}